import "../../../styles/loading.scss";

import PropTypes from "prop-types";
import React from "react";

export const loadingTypes = {
    circle: "circle",
    line: "line",
};

/**
 * Renders a loading icon according to params
 * 
 * @param {object} props
 * @returns {node}
 */
function Loading({className, height, width, loadingSize, type, points, pointWidth, lapTime, clockwise, color}) {
    const createCircle = () => {
        const nodes = [];
        const pWidth = pointWidth ? pointWidth : 71.1688-(9.1778/0.1498)*(1-Math.exp(-0.1498*points));
        const offsetPosition = 50-pWidth/2;
        for(let i=0; i<points; i++){
            const angle = Math.PI*2*(i/points);
            nodes[i] = (
                <div key={i} style={{
                    position:"absolute",
                    left: `${offsetPosition+Math.sin(angle)*offsetPosition}%`,
                    top: `${offsetPosition+Math.cos(angle)*offsetPosition}%`,
                    width: `${pWidth}%`,
                    height: `${pWidth}%`,
                }}>
                    <div className="pulsating-circle" style={{
                        animation:`pulse-dot ${lapTime}s cubic-bezier(0, 0, 1, 1) ${(clockwise?1-i/points:i/points)*lapTime-lapTime}s infinite`,
                        backgroundColor:color,
                        boxShadow:color?`0 0 8px ${color}`:undefined,
                    }} />
                </div>
            );
        }
        return nodes;
    };

    return type===loadingTypes.circle ? (
        <div className={`loading-backgroud ${className}`} style={{width:width, height:height}}>
            <div className="loading-wrapper" style={{width:`${loadingSize}%`, paddingTop:`${loadingSize}%`}}>
                <div className="loading-container">
                    {createCircle()}
                </div>
            </div>
        </div>
    ) : (
        <div style={{width:`${(height-16)*7}px`, height:`${height-16}px`, margin:"auto"}}>
            <div className="loading-wrapper-line">
                <div className="loading-container">
                    <div className="pos1">
                        <div className="pulsating-circle pulsating-circle1"/>
                    </div>
                    <div className="pos2">
                        <div className="pulsating-circle pulsating-circle2"/>
                    </div>
                    <div className="pos3">
                        <div className="pulsating-circle pulsating-circle3"/>
                    </div>
                    <div className="pos4">
                        <div className="pulsating-circle pulsating-circle4"/>
                    </div>
                    <div className="pos5">
                        <div className="pulsating-circle pulsating-circle5"/>
                    </div>
                    <div className="pos6">
                        <div className="pulsating-circle pulsating-circle6"/>
                    </div>
                    <div className="pos7">
                        <div className="pulsating-circle pulsating-circle7"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

Loading.propTypes = {
    //className of the wrapper div
    className: PropTypes.string,
    //style string, or number for pixels
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    //style string, or number for pixels
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    //size in percentage [0, 100]. Default value 100
    loadingSize: PropTypes.number,
    //what type of loader, one of loadingTypes
    type: PropTypes.oneOf([loadingTypes.circle, loadingTypes.line]),
    //Number of dots in the circle
    points: PropTypes.number,
    //Manualy set of the dot size [0, 100]. default: Auto calculated
    pointWidth: PropTypes.number,
    //Time for the animation to complete in seconds
    lapTime: PropTypes.number,
    //clockwise rottation
    clockwise: PropTypes.bool,
    //color of the circles
    color: PropTypes.string,
};

Loading.defaultProps = {
    height: "128px",
    type: loadingTypes.circle,
    loadingSize: 100,
    points: 12,
    lapTime: 2.0,
    clockwise: true,
};

export default Loading;